import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../localization/react'

import NoNotificationsImage from './assets/no-notifications.svg'

const NoNotifications = () => {
  return (
    <Stack justifyContent="center" alignItems="center" sx={{ textAlign: 'center' }} gap={4}>
      <img src={NoNotificationsImage} width="240px" height="240px" />
      <div>
        <Heading is="h2" sx={{ color: 'darkgray' }}>
          <Localized id="no-notifications-title" />
        </Heading>
        <Text sx={{ color: 'carbon' }}>
          <Localized id="no-notifications-description" />
        </Text>
      </div>
    </Stack>
  )
}

export default NoNotifications
